// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__-zuxX","disabled":"CustomButton_disabled__nCZod"};